var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "analysis-wrapper" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        _vm._l(_vm.charts, function(chart, index) {
          return _c(
            "el-col",
            { key: index, attrs: { span: 6 } },
            [
              _c(
                "el-card",
                { staticClass: "chart-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "chart-title" }, [
                    _vm._v(_vm._s(chart.title))
                  ]),
                  _c("div", {
                    ref: "chart" + index,
                    refInFor: true,
                    staticClass: "chart-container"
                  })
                ]
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }